import {
  BULK_UPLOAD_MOTORCYCLE_LIST_START,
  BULK_UPLOAD_MOTORCYCLE_LIST_SUCCESS,
  BULK_UPLOAD_MOTORCYCLE_LIST_ERROR,
  GET_MOTORCYCLE_BY_ID_START,
  GET_MOTORCYCLE_BY_ID_SUCCESS,
  GET_MOTORCYCLE_BY_ID_ERROR,
  QUICK_EDIT_MOTORCYCLE_START,
  QUICK_EDIT_MOTORCYCLE_SUCCESS,
  QUICK_EDIT_MOTORCYCLE_ERROR,
  PENDING_VERIFICATION_MOTORCYCLE_START,
  PENDING_VERIFICATION_MOTORCYCLE_SUCCESS,
  PENDING_VERIFICATION_MOTORCYCLE_ERROR,
} from "Constant";

const initialState = {
  loading: false,
  bulkuploadList: [],
  getMotorCyclceById: [],
  editMotorcycle: [],
  quicEdit: [],
  pendingList: []
};

export default function faqOperatorReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case PENDING_VERIFICATION_MOTORCYCLE_START:
      return {
        ...state,
        loading: true,
      };
    case PENDING_VERIFICATION_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        pendingList: action.payload,
        loading: false,
      };
    case PENDING_VERIFICATION_MOTORCYCLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BULK_UPLOAD_MOTORCYCLE_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case BULK_UPLOAD_MOTORCYCLE_LIST_SUCCESS:
      return {
        ...state,
        bulkuploadList: action.payload,
        loading: false,
      };
    case BULK_UPLOAD_MOTORCYCLE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case GET_MOTORCYCLE_BY_ID_START:
      return {
        ...state,
        loading: true,
      };
    case GET_MOTORCYCLE_BY_ID_SUCCESS:
      return {
        ...state,
        getMotorCyclceById: action.payload,
        loading: false,
      };
    case GET_MOTORCYCLE_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case QUICK_EDIT_MOTORCYCLE_START:
      return {
        ...state,
        loading: true,
      };
    case QUICK_EDIT_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        quicEdit: action.payload,
        loading: false,
      };
    case QUICK_EDIT_MOTORCYCLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
